// Janela de resposta do canal (Fase 12, exposta na tela em 09/09).
//
// Vive num arquivo próprio, e não dentro do Composer, por um motivo só: é a
// regra que decide se o atendente consegue ou não falar com o cliente, e regra
// assim precisa de teste. Dentro do componente ela só seria exercitada
// renderizando React.
//
// A regra em si: em canal com `hasResponseWindow` — hoje só o WhatsApp oficial
// — a Meta entrega texto livre por 24 horas contadas da última mensagem DO
// CLIENTE. Passado isso, só template aprovado.

export interface EstadoDaJanela {
  /** A caixa de digitar deve ficar travada? */
  bloqueado: boolean;
  /** Preenchido quando bloqueado — é o texto que o atendente lê. */
  motivo?: string;
}

/**
 * @param temJanela  `capabilities.hasResponseWindow` da conexão.
 * @param expiraEm   `window_expires_at` da conversa.
 * @param agora      injetado para o teste não depender do relógio.
 */
export function estadoDaJanela(
  temJanela: boolean | undefined,
  expiraEm: string | null | undefined,
  agora: Date = new Date(),
): EstadoDaJanela {
  // Canal sem janela nunca bloqueia. É o caso da maioria — WhatsApp
  // não-oficial, e-mail, Instagram — e sair cedo aqui é o que evita o
  // componente ramificar por tipo de canal.
  if (!temJanela) return { bloqueado: false };

  // Sem data, a conversa nunca recebeu mensagem do cliente. Tratar como ABERTA
  // seria o erro perigoso: deixaria passar exatamente o caso em que ninguém
  // do outro lado escreveu, que é quando a Meta mais recusa.
  if (!expiraEm) {
    return {
      bloqueado: true,
      motivo: 'Este canal só entrega mensagem depois que o cliente escrever primeiro.',
    };
  }

  const fim = new Date(expiraEm).getTime();

  // Data inválida vinda do banco: mesma lógica do campo ausente — fecha.
  if (Number.isNaN(fim)) {
    return {
      bloqueado: true,
      motivo: 'Não foi possível confirmar a janela de resposta deste canal.',
    };
  }

  if (fim <= agora.getTime()) {
    return {
      bloqueado: true,
      motivo:
        'Passaram mais de 24 horas desde a última mensagem do cliente. ' +
        'Neste canal, só um modelo de mensagem aprovado é entregue depois disso.',
    };
  }

  return { bloqueado: false };
}
